import { createStore, applyMiddleware, combineReducers, compose } from 'redux';

import { keaReducer } from '../reducer';
import { globalPlugins, activatePlugin } from '../plugins';

var reduxDevToolsCompose = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;

var defaultOptions = {
  paths: ['kea', 'scenes'],
  reducers: {},
  preloadedState: undefined,
  middleware: [],
  compose: reduxDevToolsCompose,
  enhancers: [],
  plugins: []
};

export function getStore() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // clone options
  var options = Object.assign({}, defaultOptions, opts);

  // activate all the global plugins
  options.plugins.forEach(function (plugin) {
    activatePlugin(plugin);
  });

  // clone reducers
  options.reducers = Object.assign({}, options.reducers);
  options.paths.forEach(function (path) {
    options.reducers[path] = keaReducer(path);
  });

  // run pre-hooks
  globalPlugins.beforeReduxStore.forEach(function (f) {
    return f(options);
  });

  // combine middleware into the first enhancer
  if (options.middleware.length > 0) {
    options.enhancers = [applyMiddleware.apply(undefined, options.middleware)].concat(options.enhancers);
  }

  // use a special compose function?
  var composeEnchancer = options.compose || compose;

  // create the store creator
  var finalCreateStore = composeEnchancer.apply(undefined, options.enhancers)(createStore);

  // combine reducers
  var combinedReducers = combineReducers(options.reducers);

  // create store
  var store = finalCreateStore(combinedReducers, options.preloadedState);

  // run post-hooks
  globalPlugins.afterReduxStore.forEach(function (f) {
    return f(options, store);
  });

  return store;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/kea/es/kea/store/index.js
// module id = 204
// module chunks = 0